import React  from "react";
import RewardTable from "./components/RewardTable";
import { connect } from "react-redux";


const Rewards = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<RewardTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Rewards);